import { CATEGORY_ACTION } from './actions';

export const userCategoryAction = (data) => {
    return { type: CATEGORY_ACTION, payload: data };
}